import React from 'react';

const Video = () => {
  return (
    <section id="video" className="section bg-dark">
      <div className="container">
        <h2 className="section-title">Siente el Poder de LactiGo en Acción</h2>
        <div className="ratio ratio-16x9">
          <iframe 
            src="https://www.youtube.com/embed/_1BcHEITrfY" 
            title="Video Promocional LactiGo" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
            className="rounded shadow-lg"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Video;